module.exports = __webpack_public_path__ + "static/media/deposit.b6316a6c.png";